import React from 'react';
import classNames from 'classnames';
import useThemeVersion from '@/hooks/useThemeVersion';
import LegacyWarningLabel from './LegacyWarningLabel';

type Props = {
  className?: string;
  size?: 'small' | 'medium' | 'large';
  text?: string;
};

const WarningLabelV2 = ({ className, size = 'medium', text }: Props) => (
  <div className={classNames('warning-label', className, size)}>
    <i className="icon-ds-warning" />
    {text && <span>{text}</span>}
  </div>
);

const WarningLabel = (props: Props) => {
  const { isLightVersion } = useThemeVersion();
  if (isLightVersion) {
    return <WarningLabelV2 {...props} />;
  }
  return <LegacyWarningLabel {...props} />;
};

export default WarningLabel;
